/**
 * 🏗️ FSD Shared Layer - Activity Utils
 * 
 * ActivityPage에서 사용되는 포맷팅 유틸리티 함수들
 */ /**
 * 날짜를 한국어 형식으로 포맷팅
 */ export var formatDate = function(dateStr) {
    var date = new Date(dateStr);
    return new Intl.DateTimeFormat('ko-KR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long'
    }).format(date);
};
